import { isArray } from 'lodash'
import * as services from '../../app/auth/services.js'
import { setToken } from './index.js'
import { appUrl } from '../../config'

// Re-entrancy guard: a logged-out deep-link boots the SPA and fires several
// API calls at once, so multiple 401s arrive in the same tick. Only the FIRST
// may navigate — otherwise a later 401 re-assigns window.location and the last
// write wins (previously flipping the bounce to /logout). Reset per page load.
let lmsBounceInProgress = false

export default (http, store, router) => {

    // Add a request interceptor
    http.interceptors.request.use(
        config => {

            if (! config.hideLoader ) {
                // Show loader
                $('.pace').removeClass('pace-inactive');
                $('.pace').addClass('pace-active');
            }

            // Add X-Page-URL header for activity logging
            if (typeof window !== 'undefined' && window.location) {
                const currentPath = window.location.pathname || '/';
                const fullUrl = window.location.origin + currentPath;
                
                // Handle different axios versions - headers can be object or AxiosHeaders class
                if (config.headers && typeof config.headers.set === 'function') {
                    // Axios 1.x with AxiosHeaders
                    config.headers.set('X-Page-URL', fullUrl);
                } else if (config.headers) {
                    // Axios 0.x with plain object
                    config.headers['X-Page-URL'] = fullUrl;
                } else {
                    // Fallback - create headers object
                    config.headers = { 'X-Page-URL': fullUrl };
                }
            }

            store.dispatch('setFetching', { fetching: true })

            // Do something before request is sent
            return config;
        },
        (error) => {

            // Do something with request error
            return Promise.reject(error);
        }
    ),

    // https://github.com/mzabriskie/axios#interceptors
    http.interceptors.response.use(

        response => {
            if (! response.config.hideLoader ) {
                // Remove loader
                $('.pace').removeClass('pace-active');
                $('.pace').addClass('pace-inactive');
            }

            store.dispatch('setFetching', { fetching: false })

            return response
        },

        /**
        * This is a central point to handle all
        * error messages generated by HTTP
        * requests
        */
        (error) => {

            if (! error.config.hideLoader ) {
                // Remove loader
                $('.pace').removeClass('pace-active');
                $('.pace').addClass('pace-inactive');
            }

            const { response } = error

            /**
            * If token is either expired, not provided or invalid
            * then redirect to login. On server side the error
            * messages can be changed on app/Providers/EventServiceProvider.php
            */
            if (response.status == 401 && !lmsBounceInProgress) {

               // store.dispatch('setToken', null)
                //store.dispatch('setUser', {})

                // Only the first 401 of this page load may navigate. Concurrent
                // 401s (detail + recipients + shell bootstrap) must not each
                // re-assign window.location, or the last write wins.
                lmsBounceInProgress = true;

                // Cross-subdomain deep-link recovery: instead of a hard logout to
                // the app, bounce to the app-side SSO bridge remembering where we
                // were headed (e.g. an LMS approval detail page from an email). The
                // bridge logs the user in on the app origin and hands off back here.
                var base = appUrl.replace(/\/$/, '');
                var lmsTarget = window.location.pathname + window.location.search;

                // TEMP LMS-SSO-DEBUG — remove after diagnosis
                try {
                    console.log('[LMS-SSO-DEBUG] clientv2 401', {
                        requestUrl: (error.config && error.config.url),
                        pathname: window.location.pathname,
                        search: window.location.search,
                        lmsTarget: lmsTarget,
                        appUrl: appUrl,
                        bounces: sessionStorage.getItem('lms_sso_bounces')
                    });
                } catch (e) { /* noop */ }

                // Loop-breaker: count bounces across the app<->LMS round-trip (one
                // increment per page load, thanks to the guard above). If a valid
                // session still isn't produced after a few tries, fall back to a
                // clean logout instead of ping-ponging between the two origins.
                var bounces = parseInt(sessionStorage.getItem('lms_sso_bounces') || '0', 10) + 1;
                if (bounces > 3) {
                    sessionStorage.removeItem('lms_sso_bounces');
                    try { console.log('[LMS-SSO-DEBUG] clientv2 -> LOGOUT (loop-breaker)'); } catch (e) { /* noop */ }
                    window.location = base + '/logout';
                } else {
                    sessionStorage.setItem('lms_sso_bounces', String(bounces));
                    var bounceUrl = base + '/lms-sso?redirect=' + encodeURIComponent(lmsTarget);
                    try { console.log('[LMS-SSO-DEBUG] clientv2 -> bounce', bounceUrl); } catch (e) { /* noop */ }
                    window.location = bounceUrl;
                }
                //router.push({ name: 'auth.login' })
            }

            store.dispatch('resetMessages')

            /**
            * Error messages are sent in arrays
            */
            if (response.data.errors && typeof response.data.errors === 'object') {
                store.dispatch('setMessage', { type: 'error', message: response.data.errors })
            } else {
                if (response.data.message) {
                    store.dispatch('setMessage', { type: 'warning', message: response.data.message })
                }
            }



            /**
             * Laravel generated validation errors are
             * sent in an object
             */
            // if (response.data.message) {
            //     store.dispatch('setMessage', { type: 'validation', message: response.data.message })
            // }

            store.dispatch('setFetching', { fetching: false })

            return Promise.reject(error)
        }
    )
}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors.js